module.exports = __webpack_public_path__ + "static/cercazone_nordest4-51ed76f1204e7d94e34fb9205b6efe9f.jpg";